import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getConversionMetrics } from "../../api/region";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";

// Chart options builder
const getChartOptions = (data, color) => ({
  chart: {
    type: "spline",
    height: 50,
    backgroundColor: "transparent",
    margin: [2, 0, 2, 0],
  },
  title: { text: null },
  credits: { enabled: false },
  xAxis: {
    visible: false,
    categories: data.map((_, index) => index + 1), // Add dummy categories
  },
  yAxis: {
    visible: false,
  },
  tooltip: {
    enabled: true,
    useHTML: true,
    backgroundColor: "#fff",
    borderColor: color,
    borderRadius: 6,
    shadow: true,
    padding: 8,
    style: {
      fontSize: "12px",
      color: "#000",
    },
    pointFormat: `<b>{point.y}</b>`, // THIS is what shows the value
  },
  legend: { enabled: false },
  plotOptions: {
    spline: {
      lineWidth: 2,
      marker: {
        enabled: false,
        radius: 3,
        symbol: "circle",
      },
    },
    series: {
      color,
    },
  },
  series: [
    {
      name: "Users",
      data: data,
      enableMouseTracking: true,
    },
  ],
});


const MetricCard = ({ title, value, subtitle, data, color }) => (
  <Box
    border="1px solid #eee"
    borderRadius={2}
    p={2}
    height={130}
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    alignItems="center"
  >
    {/* LEFT SIDE */}
    <Box>
      <Typography fontWeight="500" color="#3E3E3E" fontSize={16}>
        {title}
      </Typography>
      <Typography fontSize={24} color="#3C4043" fontWeight={600}>
        {value}
      </Typography>
      <Typography fontSize={14} color="#757575">
        {subtitle}
      </Typography>
    </Box>

    {/* RIGHT SIDE CHART */}
    {/* <Box width={100} height={50}>
      <HighchartsReact
        highcharts={Highcharts}
        options={getChartOptions(data, color)}
      />
    </Box> */}
  </Box>
);

const ConversionMetrics = () => {
  const [conversionData, setConversionData] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
  const { filter } = useSelector((state) => state);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await getConversionMetrics(filter);
      // console.log("data", data);
      setConversionData(data.length > 0 ? data[0] : {});
      setIsLoading(false);
    } catch (err) {
      console.error("Error while loading user data", err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);
  return (
    <Box p={2} sx={{ boxShadow: 'none', border: '1px solid #e6e6e6', borderRadius: '20px', p: 2 }}>
      <Typography fontWeight="500" fontSize={20} color="#3C4043" mb={2}>
        Conversion Metrics
      </Typography>
      {isLoading ?
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> :
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <MetricCard
              title="100 % Profile Completion"
              value={conversionData?.profileCompleted || 0}
              subtitle={`of ${conversionData?.newSignups || 0} new signups have completed profiles`}
            // data={profileData}
            // color="#f44336"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MetricCard
              title="Free to Paid User Conversion"
              value={conversionData?.paidUsers || 0}
              subtitle={`of ${conversionData?.profileCompleted || 0} free users converted to premium`}
            // data={conversionData}
            // color="#4caf50"
            />
          </Grid>
        </Grid>
      }
    </Box>
  );
};

export default ConversionMetrics;
